<template>
  <div class="flex-grow">
    <div class="bg-theme-light">
      <div class="section container grid grid-cols-3 gap-3 py-16 mx-auto px-5">
        <h1 class="col-span-3 text-2xl px-10 md:text-5xl text-theme-blue font-semibold">{{detail.name}}</h1>
      </div>
    </div>     
    <div v-if="detail.description" class="section container grid grid-cols-3 gap-3 py-16 mx-auto px-5">
        <p class="col-span-3">{{detail.description}}</p>
    </div>     
 
    <div class="section container mx-auto px-5 grid grid-cols-3 gap-5 md:my-12">
       
      <div class="col-span-3 lg:col-span-1 lg:order-last">
        <!-- <div class="card bg-gray-50 rounded-lg shadow-md"> -->
        <div class="">
          <ul class="p-5">
            <li v-if="detail.address" class="flex mt-5"><i class="text-theme-sky"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg></i> <span class="ml-2 font-semibold">{{detail.address}}</span> </li>
            <li v-if="detail.phone" class="flex mt-5"><i class="text-theme-sky"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg></i> 
                  <a :href="`tel:${detail.phone}`" target="_blank" class="hover:text-gray-500">
                    <span class="ml-2 font-semibold break-all">{{detail.phone}}</span>
                  </a>
             </li>
            <li v-if="detail.opening" class="flex mt-5"><i class="text-theme-sky"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg></i> 
                  <span class="ml-2 font-semibold break-all">{{detail.opening}}</span> 
            </li>
                  
            <li v-if="detail.email" class="flex mt-5"><i class="text-theme-sky"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg></i> 
                  <a :href="`mailto:${detail.email}`" target="_blank" class="hover:text-gray-500">
                    <span class="ml-2 font-semibold break-all">{{detail.email}}</span> 
                  </a>
            </li>

            <li v-if="detail.facebook" class="flex mt-5">
                  <Icons name="facebook" class="text-theme-sky h-6 w-6 fill-current" />
                  <a :href="`https://www.facebook.com/${detail.facebook}`" target="_blank" class="hover:text-gray-500">
                    <span class="ml-2 font-semibold break-all">{{detail.facebook}}</span> 
                  </a>
            </li>

            <li v-if="detail.instagram" class="flex mt-5">
                  <Icons name="instagram" class="text-theme-sky h-6 w-6 fill-current" />
                  <a :href="`https://www.instagram.com/${detail.instagram}`" target="_blank" class="hover:text-gray-500">
                    <span class="ml-2 font-semibold break-all">{{detail.instagram}}</span> 
                  </a>
            </li>

            <li v-if="detail.twitter" class="flex mt-5">
                  <Icons name="twitter" class="text-theme-sky h-6 w-6 fill-current" />
                  <a :href="`https://www.twitter.com/${detail.twitter}`" target="_blank" class="hover:text-gray-500">
                    <span class="ml-2 font-semibold break-all">{{detail.twitter}}</span> 
                  </a>
            </li>

            <li v-if="detail.youtube" class="flex mt-5">
                  <Icons name="youtube" class="text-theme-sky h-6 w-6 fill-current" />
                  <a :href="`https://www.youtube.com/${detail.youtube}`" target="_blank" class="hover:text-gray-500">
                    <span class="ml-2 font-semibold break-all">{{detail.youtube}}</span> 
                  </a>
            </li>

            <li v-if="detail.link" class="flex mt-5">
                  <Icons name="link" class="text-theme-sky h-6 w-6 " />
                  <a :href="detail.link" target="_blank" class="hover:text-gray-500">
                    <span class="ml-2 font-semibold break-all">{{detail.link}}</span> 
                  </a>
            </li>


            <li v-if="detail.location" class="flex mt-8">
                <a :href="detail.location" target="_blank">
                  <span class="ml-1 text-md py-2 px-3 rounded-lg bg-theme-blue text-white ">Ver Ubicación en GMAPS</span>
                </a>  
            </li>
         </ul>
     
        </div>

        
      </div> 

      <div class="col-span-3 lg:col-span-2">
        <div class="form">
          <!-- <div class="flex flex-col mt-8 mx-auto justify-center lg:flex-row lg:flex-wrap"> -->
          <div class=" grid grid-cols-5 gap-2 my-4">
            <input v-model="filterTitle" id="filterTitle" type="text" 
                   @keyup.enter="getBooks"
                   class="col-span-5 md:col-span-2 w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg 
                          focus:border-blue-500 focus:outline-none focus:ring 
                          mt-4"
                    placeholder="Título">

            <input id="select" type="text" v-model="filterAutor"
                    class="col-span-5 md:col-span-2 w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg 
                          focus:border-blue-500 focus:outline-none focus:ring mt-4" 
                          placeholder="Autor"
                    @keyup.enter="getBooks">
                  
            <button  @click.prevent="getBooks" class="col-span-5 md:col-span-1 flex items-center justify-center text-center px-4 py-2 font-medium text-white uppercase transition-colors duration-200 transform bg-theme-blue rounded-lg 
                          mt-4 
                          hover:bg-indigo-400 focus:outline-none focus:bg-indigo-400 lg:text-sm"> 
                          <!--  lg:w-2/5 lg:mx-2 lg:mt-2 xl:w-1/5 xl:mx-1 -->
              <span class="font-semibold">Buscar</span>    
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
            </button>
          </div>
        </div>  
        
        <div class="">    
            <div v-if="this.filter.length > 0" class="w-full" @click="clearFilter"><button class="ml-auto my-4 flex items-center justify-center rounded-lg border border-red-400 text-red-400 py-1 px-2 text-sm
                                hover:bg-red-400 hover:text-white">
              <Icons name="trash" class="w-4 mr-2"/><span class="tracking-wider">LIMPIAR FILTRO</span></button>
            </div>            

            <div v-show="books.total == 0" class="flex justify-center items-center"> 
              <div>No se encontraron resultados</div>
            </div>
            
            <div v-for="book in books.data" :key="book.id" class="bg-gray-50 my-5 rounded-lg py-3 px-5 shadow">
                <div class="title h-1/2 text-xl font-bold">{{book.title}}</div>
                <div class="autor text-theme-blue capitalize">{{book.lastname.toLowerCase()}}, {{book.name.toLowerCase()}}</div>
                <div class="flex justify-between mt-3"><div class="editorial text-sm text-gray-600">{{book.editorial}} - {{book.city}} - {{book.year}}</div></div>
            </div>

            <div v-show="books" class="flex justify-between items-center">
                <div v-if="books.total > 0">
                  Resultados encontrados: {{this.books.total}}
                </div>
                <div class="flex justify-end">
                  <div v-if="this.prevpage" @click="getBooksPaginate(this.prevpage)" class="cursor-pointer bg-theme-sky text-white text-sm rounded-lg py-2 px-4 flex items-center mr-4 hover:bg-theme-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
                    ATRAS
                  </div>
                  <div v-if="this.nextpage" @click="getBooksPaginate(this.nextpage)" class="cursor-pointer bg-theme-sky text-white text-sm rounded-lg py-2 px-4 flex items-center hover:bg-theme-blue">
                    SIGUIENTE<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
                  </div>
                </div>
            </div>     
        </div>         
      
      </div> 

    </div>

  </div> 

</template>

<script>
import Icons from '@/components/Icons.vue'  


export default {
  name: "BiblioDetail", 
  props:['id'],    
  components: {
    Icons
  },
  setup() {
      const img_banner = require('@/assets/images/home/banner1.svg')
      return {
        img_banner,
        
        }
  },
  data(){
      return{
        idLibrary: this.$props.id,
        detail: "",
        books:"",
        filterTitle: "",        
        filterAutor: "",
        filter: "",        
        nextpage:"",
        prevpage:"",     
        authors:""   
      }
  },
  methods: {
    async getLibraryDetail(){
      var filter = `?id=${this.$props.id}`
      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/libraries${filter}`
      const response = await fetch(get,{method: 'GET'})
      this.detail = await response.json()
    },

    async getBooks(){

      let filter = ""
      if(this.filterAutor){
        filter += `&autor=${this.filterAutor}`
      }
      if(this.filterTitle){
        filter += `&title=${this.filterTitle}`
      }
      
      this.filter= filter

      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/books?library=${this.idLibrary}${filter}`;
      const response = await fetch(get,{method: 'GET'})
      this.books = await response.json()
      console.log(this.books)
      this.nextpage = this.books.next_page_url
      this.prevpage = this.books.prev_page_url      
    },
    
    clearFilter(){

        this.filterTitle =  ""
        this.filterAutor =  ""
        this.filter =  ""
        
        this.getBooks()

    },

    async getBooksPaginate(link){

      var get = `${link}`;
      const response = await fetch(get,{method: 'GET'})

      this.books = await response.json()
      this.nextpage = this.books.next_page_url
      this.prevpage = this.books.prev_page_url

    },

    async getAuthors(){

        var get = `${process.env.VUE_APP_URL_CULTURAPP}api/books/authors`;
        const response = await fetch(get,{method: 'GET'})
        this.authors = await response.json()
    }    

  },
  mounted () {
    window.scrollTo(0, 0)
  },   
  created(){
    this.getLibraryDetail()
    this.getBooks()
    this.getAuthors()
  }
};
</script>
